<template>
  <div class="shipping-tab p-4">
    <div class="text-center mb-3">
      <a class="btn btn-primary" href="#" target="_blank"
        >Print Shipping Details</a
      >
    </div>


    <div class="details-pane-table">
      <div class="row mb-2">
        <div class="col-4 col-attribute">Shipping Contact:</div>
        <div class="col-8 col-value">
          <div v-html="event.shipping_contact"></div>
          <div v-html="event.shipping_phone"></div>
        </div>
      </div>
      <div class="row mb-2">
        <hr class="col-10 separator"/>
      </div>
      <div class="row">
        <div class="col-4 col-attribute">Ship Materials To:</div>
        <div class="col-8 col-value" v-html="event.shippingAddress"></div>
      </div>
    </div>

    <template v-if="!loaded">
      <div class="text-center">
        <icon icon="loading" class="loading-icon" />
      </div>
    </template>

    <template v-else-if="orders.length > 0">
      <template v-for="(order, o) in orders">
        <hr :key="`hr-${o}`" />
        <div :key="`table-${o}`" class="details-pane-table mb-3">
          <div class="row mb-2">
            <div class="col-4 col-attribute">Order No.:</div>
            <div class="col-8 col-value"></div>
          </div>
          <div class="row mb-2">
            <div class="col-4 col-attribute">Status:</div>
            <div class="col-8 col-value">{{ orderStatus(order) }}</div>
          </div>
          <div v-if="!!order.trackingUrl" class="row mb-2">
            <div class="col-4 col-attribute">Tracking No.:</div>
            <div class="col-8 col-value">
              <a
                :href="order.trackingUrl"
                target="_blank"
                title="Track Shipment"
                >{{ order.tracking_number || "Track Shipment" }}</a
              >
            </div>
          </div>
          <div v-if="order.materials.length > 0" class="row mb-2">
            <div class="col-4 col-attribute">Materials:</div>
            <div class="col-8 col-value">
              <div v-for="(material, m) in order.materials" :key="m">
                {{ material.number + ` (x${material.pivot.num_ordered})` }}
              </div>
            </div>
          </div>
        </div>
      </template>
    </template>
  </div>
</template>

<script>
export default {
  props: {
    event: { type: Object, required: true },
  },

  data() {
    return {
      orders: [],
      loaded: false,
    };
  },

  watch: {
    event(model) {
      this.loaded = false;
      this.load();
    },
  },

  methods: {
    load() {
      this.axios
        .get(this.route("catalog.event.orders", { event: this.event.id }))
        .then((response) => {
          this.orders = response.data;
          this.loaded = true;
        });
    },
    orderStatus(order) {
      var status = order.status_label;
      if (order.status === this.$root.constants.SHIPPED_ORDER) {
        status += " on " + this.$moment(order.shipped_at).format("M/D/YY");
      } else if (order.status === this.$root.constants.ARRIVED_ORDER) {
        status += " on " + this.$moment(order.arrived_at).format("M/D/YY");
      }
      return status;
    },
  },

  mounted() {
    this.load();
  },
};
</script>